import axios from 'axios'

interface VisitorInfoResponseInterface {
  country: string | null
}

export const getVisitorInfo = () =>
  axios.get<VisitorInfoResponseInterface>(
    `/api/monolith/public/pages/visitor-info`,
  )
